import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { SidebarLayout } from '@/components/layouts/SidebarLayout'

export default function New() {
  const { data, setData, post, processing, errors } = useForm({
    secret: {
      name: '',
      description: '',
      secret: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/manage/secrets')
  }

  return (
    <SidebarLayout section="manage" title="New secret">
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          maxWidth: 600,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Name"
            fullWidth
            autoFocus
            value={data.secret.name}
            onChange={e => setData('secret', { ...data.secret, name: e.target.value })}
            error={'secret.name' in errors}
            helperText={(errors as Record<string, string>)['secret.name'] || 'e.g. OPENAI_API_KEY'}
            sx={{ mb: 2.5 }}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={2}
            value={data.secret.description}
            onChange={e => setData('secret', { ...data.secret, description: e.target.value })}
            error={'secret.description' in errors}
            helperText={(errors as Record<string, string>)['secret.description']}
            sx={{ mb: 2.5 }}
          />
          <TextField
            label="Secret value"
            fullWidth
            multiline
            minRows={4}
            value={data.secret.secret}
            onChange={e => setData('secret', { ...data.secret, secret: e.target.value })}
            error={'secret.secret' in errors}
            helperText={(errors as Record<string, string>)['secret.secret']}
            sx={{ mb: 3 }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={processing}
            sx={{ mb: 2 }}
          >
            Create secret
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Link href="/manage/secrets" style={{ color: '#1a1a1a' }}>Back to secrets</Link>
          </Box>
        </Box>
      </Paper>
    </SidebarLayout>
  )
}
